import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-money",
  "use": "icon-money-usage",
  "viewBox": "0 0 1025 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1025 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-money\"><path d=\"M873.545 149.984c-199.968-199.968-523.104-199.968-723.072 0s-200.96 524.032-0.992 724c199.968 200 525.056 200 725.056 0 199.968-199.968 198.976-524.032-0.992-724z m-172.032 333.76v101.152H562.92v40.608h138.592v99.68H562.92v107.904h-111.2V725.184H313.737v-99.68H451.72v-40.608H313.737V483.744h83.968L269.769 234.432h126.688l82.272 170.848c10.432 21.952 17.824 35.424 22.208 52.16 5.216-18.112 12.64-31.584 22.24-52.16l83.904-170.848h126.688L604.2 483.744h97.312z\" p-id=\"53743\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/money.svg
// module id = IF5j
// module chunks = 12